//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherPayrollType, TeacherMakeupCreditPaymentBehaviour } from './Enums';

export class TeacherPayrollSettingsInputItem extends ItemBase {
    Type: TeacherPayrollType = TeacherPayrollType.None;
    MakeupCreditPaymentBehaviour: TeacherMakeupCreditPaymentBehaviour | null = null;
    Rate: number | null = null;

    constructor(initializer?: Partial<TeacherPayrollSettingsInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherPayrollSettingsInputItem";
}
